import {NumberInputTypes} from '../constants';

import type {NumberInputType} from '../typedef';

type Props = {
    inputType: NumberInputType,
    value: string | undefined,
    onBlur: (value: number | undefined) => void,
    onError: () => void,
};

export const validateOnBlurChange = ({value, inputType, onBlur, onError}: Props) => {
    switch (inputType) {
        case NumberInputTypes.POSITIVE_INTEGER:
            if (value) {
                const parsedValue = parseInt(value, 10);
                if (isNaN(parsedValue) || parsedValue < 0) {
                    onError();
                } else {
                    onBlur(parsedValue);
                }
            } else {
                onBlur(undefined);
            }
            break;

        case NumberInputTypes.INTEGER:
            if (value) {
                const parsedValue = parseInt(value, 10);
                if (isNaN(parsedValue)) {
                    onError();
                } else {
                    onBlur(parsedValue);
                }
            } else {
                onBlur(undefined);
            }
            break;

        case NumberInputTypes.POSITIVE_FLOAT:
            if (value) {
                const parsedValue = parseFloat(value);
                if (value.endsWith('.') || isNaN(parsedValue) || parsedValue < 0) {
                    onError();
                } else {
                    onBlur(parsedValue);
                }
            } else {
                onBlur(undefined);
            }
            break;

        case NumberInputTypes.FLOAT:
            if (value) {
                const parsedValue = parseFloat(value);
                if (value.endsWith('.') || isNaN(parsedValue)) {
                    onError();
                } else {
                    onBlur(parsedValue);
                }
            } else {
                onBlur(undefined);
            }
            break;
    }
};
